import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.scss';
import '../../styles/menu.scss';
import '../../styles/container.scss';
import ImageCropper from '../../components/tools/ImageCropper';
import Stopwatch from '../../components/tools/Stopwatch';
import UnitConverter from '../../components/tools/UnitConverter';
import VideoFrameExtractor from '../../components/tools/VideoFrameExtractor';
import AudioExtractor from '../../components/tools/AudioExtractor';

const toolMenus = [
  { label: '图片裁剪', path: 'image_cropper' },
  { label: '秒表', path: 'stopwatch' },
  { label: '单位换算', path: 'unit_converter' },
  { label: '视频抽帧', path: 'video_frame_extractor' },
  { label: '音频提取', path: 'audio_extractor' }
];

export default function Tools() {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname.split('/')[2] || toolMenus[0].path;
  const activeMenu = toolMenus.find(m => m.path === activePath) || toolMenus[0];

  // 渲染工具内容
  const renderToolContent = () => {
    switch (activeMenu.path) {
      case 'image_cropper':
        return <ImageCropper />;
      case 'stopwatch':
        return <Stopwatch />;
      case 'unit_converter':
        return <UnitConverter />;
      case 'video_frame_extractor':
        return <VideoFrameExtractor />;
      case 'audio_extractor':
        return <AudioExtractor />;
      default:
        return <div className="page_content_placeholder">这里是「{activeMenu.label}」的内容区域。</div>;
    }
  };

  return (
    <div className="page_container">
      {/* 左侧菜单栏 */}
      <div className="menu_sidebar">
        {toolMenus.map(menu => (
          <div
            key={menu.path}
            onClick={() => navigate(`/tools/${menu.path}`)}
            className={`menu_item ${activePath === menu.path ? 'menu_item_active' : ''}`}
          >
            {menu.label}
          </div>
        ))}
      </div>
      {/* 右侧内容区 */}
      <div className="page_content_area">
        {renderToolContent()}
      </div>
    </div>
  );
} 